import { format } from "date-fns";

declare var Tafgeet: any;

let numericalKeys = {
  3: "ثلاثة",
  4: "اربعة",
  5: "خمسة",
  6: "ستة",
  7: "سبعة",
  8: "ثمانية",
  9: "تسعة",
  10: "عشرة",
  11: "احد عشر",
  12: "اثنى عشر",
};

let keys = {
  mon_1: "شهر",
  mon_2: "شهرين",
  mon_multi: "اشهر",
  yer_1: "سنه",
  yer_2: "سنتين",
  yer_multi: "سنوات",
};

function ParseMonthCount(value) {
  value = Number(value);
  if (value === 1) {
    return keys.mon_1;
  } else if (value === 2) {
    return keys.mon_2;
  } else if (value > 2 && value <= 10) {
    return numericalKeys[value] + " " + keys.mon_multi;
  } else if (value > 10) {
    return numericalKeys[value] + " " + keys.mon_1;
  }
}

function ParseYearCount(value) {
  value = Number(value);
  if (!Number.isInteger(value)) {
    const intPart = Math.floor(value);
    const decimalPart = Math.floor((value - intPart) * 12);
    if (intPart === 1) {
      return keys.yer_1 + " و " + ParseMonthCount(decimalPart);
    } else if (intPart === 2) {
      return keys.yer_2 + " و " + ParseMonthCount(decimalPart);
    } else if (intPart > 2 && intPart <= 10) {
      return (
        numericalKeys[intPart] +
        " " +
        keys.yer_multi +
        " و " +
        ParseMonthCount(decimalPart)
      );
    } else if (intPart > 10) {
      return (
        numericalKeys[intPart] +
        " " +
        keys.yer_1 +
        " و " +
        ParseMonthCount(decimalPart)
      );
    }
  } else {
    if (value === 1) {
      return keys.yer_1;
    } else if (value === 2) {
      return keys.yer_2;
    } else if (value > 2 && value <= 10) {
      return numericalKeys[value] + " " + keys.yer_multi;
    } else if (value > 10) {
      return numericalKeys[value] + " " + keys.yer_1;
    }
  }
}


export const printSaleReservationFile = (
  { base, system },
  reservation: any = {}
) => {
  // constants
  const layout: any = {
    letterhead: "ww-letterhead.jpg",
  };

  console.log(reservation);

  const today = new Date().toISOString().slice(0, 10);

  function formatCurrency(amount) {
    return amount.toLocaleString("en-US");
  }

  const selling_date = reservation.selling_date;

  return `<!DOCTYPE html>
  <html lang="ar" dir="rtl">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>${reservation.unit.serial}</title>


      <style>
        @font-face {
          font-family: "Cairo";
          src: url(${base}assets/fonts/Cairo-VariableFont_slnt,wght.ttf);
        }

        body {
          font-size: 12pt;
          font-family: "Cairo";
          background-size: 100vw 100vh;
          line-height: 1.7rem;
        }
        pre {
          font-family: "Cairo";
        }

        .sm-text {
          font-size: 10pt !important;
        }

        h3, h4{
          margin: 0.7rem 0 !important;
        }

        .ml-3{
          margin-inline-end: 3rem !important;
        }

        .ml-1{
          margin-inline-end: 0.5rem !important;
        }

        .mr-3{
          margin-inline-start: 0.5rem !important;
        }

        .mt-3{
          margin-top: 0.7rem !important;
        }
          
        .mt-6{
          margin-top: 1.5rem !important;
        }

        .font-bold{
          font-weight: bold;
        }

        .text-center{
          text-align:center;
        }

        .p{
          line-height: 1.4rem;
        }

        .p1{
          line-height: 1rem;
        }
        
        .p2{
          line-height: 1.8rem;
        }

        .ltr {
          direction: ltr !important;
        }

        /* table classes */
        .table {
          width: 100%;
          margin-bottom: 1rem;
          color: #212529;
          border-collapse: collapse;
        }

        .table-bordered {
          border: 1px solid #dee2e6;
        }

        .table-bordered th,
        .table-bordered td {
          padding: 0.25rem 2rem !important;
          border: 1px solid #dee2e6;
          text-align: center;
          white-space: nowrap;
        }

        /* Flex utilities */
        .d-flex {
          display: flex;
        }
        
        .flex-row{
          flex-direction: row;
        }

        .flex-column{
          flex-direction: column;
        }

        .justify-content-between {
          justify-content: space-between;
        }

       .flex-wrap{
          flex-wrap: wrap;
        }


        .underline{
          text-decoration: underline;
        }

        .justify-content-evenly {
          justify-content: space-evenly;
        }

        .justify-content-around {
          justify-content: space-around;
        }

        .justify-content-start {
          justify-content: flex-start;
        }

        .align-items-center {
          align-items: center;
        }

        .justify-content-end {
          justify-content: flex-end;
        }

        .grid {
          display: grid;
        }

        .grid-cols-4 {
            grid-template-columns: repeat(4, minmax(0, 1fr));
        }

        .grid-cols-3 {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        .min-w-max {
            min-width: max-content;
        }

        .flex-wrap {
          flex-wrap: wrap;
        }

        .w-100{
          width: 100% !important;
        }

        .w-33{
          width: 33.333% !important;
        }

        .w-50{
          width: 50% !important;
        }

        .container {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .item {
          flex: 0 0 calc(50% - 8px);
          box-sizing: border-box;
          padding-bottom: 20px;
        }

        /* custom */

        @media print {
          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          footer {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 3rem;
          }

          .page {
            position: relative;
            padding-right: 1.5rem;
            padding-left: 1.5rem;
          }
        }
          
        @page {
          size: A4 portrait;
        }
      </style>
    </head>
    <body>
      <div class="page p1">
        <div class="w-full d-flex align-items-center justify-content-end">
          ${
            reservation.installment_logo
              ? `
              <img src="${reservation.installment_logo.url}" alt="" height="70" />
              `
              : ""
          }
        </div>
        <div class="w-100">
          <h2 class="text-center underline">
            إستمـارة حـجـز
          </h2>
        </div>
        <div class="mt-3 d-flex flex-column">
          <h3 class="underline"> بيانات العميل:</h3>
          ${reservation.sharing_leads.map((lead) => {
            return `
                  <div class="w-100 mt-3">
                    <span class="font-bold ml-1">
                       الاسم : 
                    </span>
                    ${lead.lead_name}
                  </div>
                  ${
                    lead.lead_address
                      ? `
                            <div class="w-100 mt-3">
                              <span class="font-bold ml-1">
                                  العنوان : 
                              </span>
                              ${lead.lead_address}
                            </div>
                          `
                      : ""
                  }
                  <div class="w-100 mt-3 d-flex align-items-center">
                    ${
                      lead.lead_workplace
                        ? `
                              <div class="w-50">
                                <span class="font-bold ml-1">
                                    الوظيفة :
                                </span>
                                ${lead.lead_workplace}
                              </div>
                            `
                        : ""
                    }
                    ${
                      lead.lead_phone
                        ? `
                              <div class="w-50">
                                <span class="font-bold ml-1">
                                    رقم  التليفون : 
                                </span>
                                ${lead.lead_phone}
                              </div>
                            `
                        : ""
                    }
                  </div>
                  <div class="w-100 mt-3 d-flex align-items-center">
                      ${
                        lead.lead_national_id
                          ? `
                                <div class="w-33 min-w-max">
                                  <span class="font-bold ml-1">
                                      البطاقة او جواز السفر : 
                                  </span>
                                  ${lead.lead_national_id}
                                </div>
                              `
                          : ""
                      }
                      ${
                        lead.lead_issue_date
                          ? `
                                <div class="w-33">
                                  <span class="font-bold ml-1">
                                      صادر في :
                                  </span>
                                  ${lead.lead_issue_date}
                                </div>
                              `
                          : ""
                      }
                      ${
                        lead.lead_district
                          ? `
                                <div class="w-33">
                                  <span class="font-bold ml-1">
                                      محافظة /
                                  </span>
                                  ${lead.lead_district}
                                </div>
                              `
                          : ""
                      }
                    </div>

              `;
          })}
        </div>
        <div class="mt-3 d-flex flex-column">
          <h3 class="underline"> بيانات الوحدة :</h3>
          <div class="w-100 mt-3">
            <span class="font-bold ml-1">
                اسم المشروع : 
            </span>
            ${reservation.unit.project.name}
          </div>
          <div class="w-100 grid grid-cols-3">
            ${
              reservation.unit.serial
                ? `
                  <div class="w-50 mt-3 min-w-max">
                    <span class="font-bold ml-1">
                        رقم الوحدة : 
                    </span>
                    <span class="ml-1">
                      ${reservation.unit.serial}
                    </span>
                  </div>
                 `
                : ""
            }
            ${
              reservation.unit_building_area
                ? `
                  <div class="w-50 mt-3 min-w-max">
                    <span class="font-bold ml-1">
                        مساحة الوحدة: 
                    </span>
                    <span>
                      ${reservation.unit_building_area}
                    </span>
                    متر2
                  </div>
                 `
                : ""
            }
            ${
              reservation.unit_garden_area
                ? `
                  <div class="w-50 mt-3 min-w-max">
                    <span class="font-bold ml-1">
                        مساحة الحديقة: 
                    </span>
                    <span>
                      ${reservation.unit_garden_area}
                    </span>
                    متر2
                  </div>
                 `
                : ""
            }
          </div>
          <div class="w-100 grid grid-cols-3">
            ${
              reservation.unit.number
                ? `
                  <div class="w-50 mt-3 min-w-max">
                    <span class="font-bold ml-1">
                        نموذج :
                    </span>
                    ${reservation.unit.number}
                  </div>
                 `
                : ""
            }
            ${
              reservation.unit.floor_number
                ? `
                  <div class="w-50 mt-3 min-w-max">
                    <span class="font-bold ml-1">
                        رقم الدور :
                    </span>
                    ${reservation.unit.floor_number}
                  </div>
                 `
                : ""
            }
            ${
              reservation.unit.building_num
                ? `
                  <div class="w-50 mt-3 min-w-max">
                    <span class="font-bold ml-1">
                        رقم المبنى :
                    </span>
                    ${reservation.unit.building_num}
                  </div>
                 `
                : ""
            }
          </div>
          <div class="w-100 mt-3">
            <span class="font-bold ml-1">
                سعر الوحدة :
            </span>
            ${formatCurrency(Number(reservation.total_price))} جنيه</span>
            <span class="mr-3 sm-text">
              (${new Tafgeet(Number(reservation.total_price), "").parse(
                false
              )} جنيه فقط لاغير)
            </span> 
          </div>
          ${
            reservation.unit_maintenance_price
              ? `
                  <div class="w-100 mt-3">
                    <span class="font-bold ml-1">
                        سعر الصيانة :
                    </span>
                    ${formatCurrency(Number(reservation.unit_maintenance_price))} جنيه</span>
                    <span class="mr-3 sm-text">
                      (${new Tafgeet(Number(reservation.unit_maintenance_price), "").parse(
                        false
                      )} جنيه فقط لاغير)
                    </span> 
                  </div>
              `
              : ""
          }
          <div class="w-100 mt-3">
            <span class="font-bold ml-1">
                السعر الإجمالي :
            </span>
            ${formatCurrency(Number(reservation.total_price) + Number(reservation.unit_maintenance_price))} جنيه</span>
            <span class="mr-3 sm-text">
              (${new Tafgeet(Number(reservation.total_price) + Number(reservation.unit_maintenance_price), "").parse(
                false
              )} جنيه فقط لاغير)
            </span> 
          </div>
          ${
            reservation.total_down_payment
              ? `
                  <div class="w-100 mt-3">
                    <span class="font-bold ml-1">
                        دفعه الحجز : 
                    </span>
                    ${formatCurrency(
                      Number(reservation.total_down_payment)
                    )} جنيه</span>
                    <span class="mr-3 sm-text">
                      (${new Tafgeet(
                        Number(reservation.total_down_payment),
                        ""
                      ).parse(false)} جنيه فقط لاغير)
                    </span> 
                  </div>
               `
              : ""
          }
        </div>
        <div class="mt-3 d-flex flex-column">
          <h3 class="underline mt-3"> ملاحظـــات :</h3>
          <span class="mt-3 p">
            يجب على حاجز الوحدة التكرم بالحضور إلى مقر الشركة وذلك خلال 3 أيام  من تاريخ تحرير استمارة الحجز وذلك لإنهاء إجراءات التعاقد والتوقيع على عقد البيع الابتدائي طبقاً لنظام المشروع، وإلا يعتبر هذا الحجز لاغياً من تلقاء نفسه ويكون مبلغ الحجز المدفوع غير مسترد ، علما بأن الحجز بموجب هذه الاستمارة لا يرتب أي حقوق عينية أو شخصية على الوحدة
          </span>
          <div class="w-100 mt-3">
            <span class="font-bold ml-1">
              تاريخ تحرير الاستمارة : 
            </span>
            ${selling_date}
          </div>
        </div>
        <div class="d-flex flex-column">
          <h3 class="underline mt-3"> شروط خاصة بالاستمارة</h3>
          <ul class="mt-3 p">
            <li>
              تعتبر بيانات الاستمارة جزء لايتجزأ من العقد اللاحق ومكملا له
            </li>
            <li>
              يلتزم الحاجز بتسديد الأقساط السابقة فى المواعيد المحددة لها
            </li>
            <li>
              لا يعتد بأى مبالغ من المبالغ السابقة دون ايصال استلام نقدية
            </li>
          </ul>
          <div>
          <div class="d-flex justify-content-around">
            <div>
              <h3 class="text-center underline">أقر بموافقتي على هذه الشروط ( الحاجز)</h3>
              <p> اسم العميل :</p>
              <p> التوقيع :</p>
            </div>
            <div>
              <h3 class="text-center underline">إدارة المبيعات</h3>
              <p> الإسم :</p>
              <p> التوقيع :</p>
            </div>
            <div>
              <h3 class="text-center underline">يعتمد</h3>
              <p> الإسم :</p>
              <p> التوقيع :</p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </body>
  </html>
  `;
};



// WEBPACK FOOTER //
// ./src/app/reservation-view/prints/sale-reservation-file.ts